export function isNotFoundError(error: unknown): boolean {
    return (
        !!error &&
        typeof error === 'object' &&
        'status' in error &&
        (error as { status: number }).status === 404
    );
}
